import Constants from "expo-constants";
import { Authentication } from ".";

class KeycloakAuth implements Authentication {
  keycloak!: Keycloak.KeycloakInstance;

  private init() {
    /*global Keycloak */
    this.keycloak = Keycloak({
      url: Constants.manifest?.extra?.KEYCLOAK_URL + "/auth",
      clientId: Constants.manifest?.extra?.KEYCLOAK_CLIENTID ?? "430434b7",
      realm: Constants.manifest?.extra?.KEYCLOAK_REALM ?? "pvcombank",
    });
  }

  public get accessToken() {
    return this.keycloak.token;
  }
  public get re_token() {
    return this.keycloak.refreshToken;
  }

  login() {
    this.init();
    return this.keycloak.init({ onLoad: "login-required", pkceMethod: "S256", redirectUri: window.location.href });
  }

  logout() {
    this.keycloak.logout();
  }

  isTokenExpired(): boolean {
    return this.keycloak.isTokenExpired(5);
  }

  refreshToken() {
    return this.keycloak.updateToken(-1);
  }

  loadProfile() {
    return this.keycloak.loadUserProfile();
  }

  loadUserInfo() {
    return Promise.resolve({});
  }
}

export default new KeycloakAuth();
